import { render } from "./secondary.vue?vue&type=template&id=7bd3998c&scoped=true"
import script from "./secondary.vue?vue&type=script&lang=js"
export * from "./secondary.vue?vue&type=script&lang=js"

import "./secondary.vue?vue&type=style&index=0&id=7bd3998c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd3998c"]])

export default __exports__